import { render, staticRenderFns } from "./LootboxHero.vue?vue&type=template&id=3e06f61e&scoped=true&"
import script from "./LootboxHero.vue?vue&type=script&lang=js&"
export * from "./LootboxHero.vue?vue&type=script&lang=js&"
import style0 from "./LootboxHero.vue?vue&type=style&index=0&id=3e06f61e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06f61e",
  null
  
)

export default component.exports